import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import SidePanel from './SidePanel';
import FooterButton from './FooterButton';

import validateStep2 from './validateStep2';
import updateStep2 from './updateStep2';
import messages from '../../locale/jsonMessages';

import FieldArrayComponent from '../CommonFields/FieldArrayComponent';

import CommonModal from '../CommonModal/CommonModal';
import { openAIModal } from '../../actions/modalActions';
import showToaster from '../../helpers/toasterMessages/showToaster';

import locationIcon from '/public/SiteIcons/locationIdea.svg';

//Style
import cs from '../commonStyle.css';
import s from './ListPlaceStep1.css';


class Description extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      currentIndex: null
    };
  }

  UNSAFE_componentWillMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid } = nextProps;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  handleOpenAIModal = async (currentIndex) => {
    const { openAIModal, isSelectedLanguage } = this.props;
    let language = isSelectedLanguage[currentIndex]?.language
    if (!language) return await showToaster({ messageId: 'chooseLanguageError', toasterType: 'error' })
    openAIModal();
    this.setState({ currentIndex })
  }

  render() {
    const { handleSubmit, previousPage, formPage, step, listingSteps, isSelectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;
    const { isDisabled, chars_left } = this.state;

    return (
      <div className={cx(s.stepGrid, 'stepGridRTL')}>
        <SidePanel
          title={formatMessage(messages.step2Heading)}
          landingContent={formatMessage(messages.descriptionStepText)}
        />
        <CommonModal
          title={listingSteps?.step2 == "completed" ? formatMessage(messages.editTitleDescriptionLabel) : formatMessage(messages.titleDescriptionLabel)}
          formName={"ListingTitleDescriptionForm"}
          currentIndex={this.state.currentIndex}
        />
        <form onSubmit={handleSubmit}>
          <div className={s.landingMainContent}>
            <h3 className={cx(cs.spaceBottom1, cs.commonContentText)}>{listingSteps?.step2 == "completed" ? formatMessage(messages.carStep2TitleLabel1) : formatMessage(messages.carStep2TitleLabel)}</h3>
            <p className={cx(s.locationTipCss, cs.commonMediumText, cs.spaceBottom3)}><FormattedMessage {...messages.descriptionToolTip} /></p>
            <FieldArray
              name="dynamicListTitleDescription"
              component={FieldArrayComponent}
              selectedLanguage={isSelectedLanguage}
              label={listingSteps?.step2 == "completed" ? formatMessage(messages.editCarName) : formatMessage(messages.nameYourList)}
              filedName={'dynamicListTitleDescription'}
              isListing
              openAIModal={this.handleOpenAIModal}
              descListClass='becomeHostDescLanguageGrid'
            />
          </div>
          <FooterButton
            isDisabled={isDisabled}
            previousPage={previousPage}
            previousPagePath={"photos"}
            type={"submit"}
            formPage={formPage}
            step={step}
            isFinish
          />
        </form>
      </div>
    );
  }
}

Description = reduxForm({
  form: 'ListPlaceStep2', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep2,
  onSubmit: updateStep2
})(Description);

const selector = formValueSelector('ListPlaceStep2');

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  listingSteps: state.location.listingSteps,
  title: selector(state, 'title'),
  isSelectedLanguage: selector(state, 'dynamicListTitleDescription'),
  isDescriptionSelectedLanguage: selector(state, 'dynamicListDescription')

});

const mapDispatch = {
  openAIModal
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(Description)));
